<script setup lang="ts">
const { richText } = defineProps({
  richText: {
    type: String,
    required: true
  }
})
</script>
<template>
  <div v-html="richText" class="content-rich" w-full></div>
</template>
<style lang="" scoped></style>
